// extracted by mini-css-extract-plugin
export default {"AppStyles":"App_AppStyles__pHKNT"};